import Permission from "../../js/components/permission/Permission.js";

export default class SidDropdownItem {
    /** @type {string} */
    type;
    /** @type {Team|UserJson} */
    subject;
    /** @type {boolean} */
    isEnabled;

    /**
     * @param {string} type
     * @param {Team|UserJson}subject
     * @param {boolean} isEnabled
     */
    constructor(type, subject, isEnabled) {
        this.type = type;
        this.subject = subject;
        this.isEnabled = isEnabled
    }

    /** @returns {string} */
    get name (){
        return this.isTeamSid() ? this.subject.name : this.subject.displayName;
    }

    /** @returns {boolean} */
    isTeamSid() {
        return this.type === Permission.SUBJECT_TYPE.TEAM
    }

    /** @returns {boolean} */
    isUserSid() {
        return this.type === Permission.SUBJECT_TYPE.USER
    }

    /** @returns {boolean} */
    isPublicTeam(){
        return this.isTeamSid() && this.subject.isPublicTeam()
    }
}